import * as types from "./types";

/**
 * @param {object} payload ConsultationRequest
 */
export const createConsultation = (payload) => ({
  type: types.CREATE_CONSULTATION_REQUEST,
  payload
});

/**
 * @param {number} id
 */
export const deleteConsultation = (id) => ({
  type: types.DELETE_CONSULTATION_REQUEST,
  payload: { id }
});

/**
 * @param {number} id
 */
export const getConsultationById = (id) => ({
  type: types.GET_CONSULTATION_BY_ID_REQUEST,
  payload: { id }
});

/**
 * Charge la liste plate des consultations d'un patient.
 *
 * @param {number} patientId
 */
export const getConsultationsByPatient = (patientId) => ({
  type: types.GET_CONSULTATIONS_BY_PATIENT_REQUEST,
  payload: { patientId }
});
